import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useStore } from 'store';
import { RenderIf } from 'utilities/helpers';
import { Ikon } from 'assets/icons';
import styles from './index.module.css';
import { useFetchExistingPlanHook } from 'hooks/branch/useFetchExistingPlan';
import { Loading } from 'components/loading';
import { useCountry } from 'contexts/CountryContext';

// Import SVG icons
import DashboardIcon from '../../assets/svgs/Dashboard.svg';
import InventoryIcon from '../../assets/svgs/Inventory.svg';
import OverviewIcon from '../../assets/svgs/Overview.svg';
import ProductsIcon from '../../assets/svgs/Products.svg';
import MenuengineeringIcon from '../../assets/svgs/Menuengineering.svg';
import CategoriesIcon from '../../assets/svgs/Categories.svg';
import ItemsIcon from '../../assets/svgs/Items.svg';
import ModifiersIcon from '../../assets/svgs/Modifiers.svg';
import RecipeIcon from '../../assets/svgs/Recipe.svg';
import FoodwasteIcon from '../../assets/svgs/Foodwaste.svg';
import SDSIcon from '../../assets/svgs/SDS.svg';
import OrdershistoryIcon from '../../assets/svgs/Ordershistory.svg';
import DeliverysettingsIcon from '../../assets/svgs/Deliverysettings.svg';

// SVG Icon mapping
const iconMap = {
  Dashboard: DashboardIcon,
  Inventory: InventoryIcon,
  Overview: OverviewIcon,
  Products: ProductsIcon,
  Menuengineering: MenuengineeringIcon,
  Categories: CategoriesIcon,
  Items: ItemsIcon,
  Modifiers: ModifiersIcon,
  Recipe: RecipeIcon,
  Foodwaste: FoodwasteIcon,
  SDS: SDSIcon,
  Ordershistory: OrdershistoryIcon,
  Deliverysettings: DeliverysettingsIcon,
  Paymentsettings: DeliverysettingsIcon // Using Deliverysettings icon as placeholder
};

// SVG Icon Component
const SvgIcon = ({ iconName, className }) => {
  const IconComponent = iconMap[iconName];
  if (!IconComponent) return null;
  
  return (
    <img 
      src={IconComponent} 
      alt={iconName} 
      className={className}
    />
  );
};
const asideNavMain = [
  {
    label: 'Dashboard',
    svgIcon: 'Dashboard',
    route: '/dashboard',
    allowed: true,
    children: []
  },
  // {
  //   label: 'Demand Planning',
  //   svgIcon: 'demand-planning',
  //   route: '/demand-planning',
  //   children: []
  // },
  // {
  //   label: 'Online Store',
  //   svgIcon: 'online-store',
  //   route: '',
  //   children: [
  //     {
  //       label: 'Online Store Settings',
  //       svgIcon: 'online-store-settings',
  //       route: '/online-store/builder'
  //     },
  //     {
  //       label: 'Domains',
  //       svgIcon: 'online-store-domains',
  //       route: '/online-store/domains'
  //     }
  //   ]
  // },
  {
    label: 'Inventory',
    svgIcon: 'Inventory',
    route: '',
    allowed: false,
    children: [
      {
        label: 'Overview',
        svgIcon: 'Overview',
        route: '/inventory/overview',
        allowed: false
      },
      {
        label: 'Products',
        svgIcon: 'Products',
        route: '/inventory/products'
      },
      {
        label: 'Inventory',
        svgIcon: 'Inventory',
        route: '/inventory/listing'
      }
      // {
      //   label: 'Vendors',
      //   svgIcon: 'inventory-vendors',
      //   route: '/inventory/vendors'
      // },
    ]
  },
  {
    label: 'Menu Engineering',
    svgIcon: 'Menuengineering',
    route: '',
    children: [
      {
        label: 'Categories',
        svgIcon: 'Categories',
        route: '/menu-engineering/categories'
      },
      {
        label: 'Items',
        svgIcon: 'Items',
        route: '/menu-engineering/items'
      },
      {
        label: 'Modifiers',
        svgIcon: 'Modifiers',
        route: '/menu-engineering/modifiers'
      }
    ]
  },
  {
    label: 'Recipe Engineering',
    svgIcon: 'Recipe',
    route: '/recipe-engineering',
    children: []
  },
  // {
  //   label: 'Demand Sensing',
  //   svgIcon: 'sds',
  //   route: '/demand-sensing',
  //   children: []
  // },
  // {
  //   label: 'Kitchen Planning',
  //   svgIcon: 'sds',
  //   route: '/kitchen-planning',
  //   children: []
  // },
  {
    label: 'Food Waste',
    svgIcon: 'Foodwaste',
    route: '/foodwaste',
    children: [],
    allowed: true
  },
  {
    label: 'SDS',
    svgIcon: 'SDS',
    route: '/sds',
    children: []
  },
  {
    label: 'Orders History',
    svgIcon: 'Ordershistory',
    route: '/orders/history',
    children: []
  },
  {
    label: 'Delivery Settings',
    svgIcon: 'Deliverysettings',
    route: '/delivery-settings',
    children: []
  },
  {
    label: 'Payment Settings',
    svgIcon: 'Paymentsettings',
    route: '/payment-settings',
    children: [],
    countryRestricted: 'PK' // Only show for PK country
  }
];

export const NavItem = ({
  item,
  isActive,
  onParentClick,
  onChildClick,
  isWebMenu,
  pathname
}) => {
  return (
    <>
      <button
        type={`button`}
        className={
          item?.route === pathname && item?.children?.length === 0
            ? `${styles.navItem} ${styles.active}`
            : item?.children?.length !== 0 && !isActive
            ? `${styles.navItem} ${styles.ddItem}`
            : item?.children?.length !== 0 && isActive
            ? `${styles.navItem} ${styles.ddItem} ${styles.ddActive}`
            : styles.navItem
        }
        onClick={() => {
          if (!item?.allowed) {
            return; // Prevent navigation for paid features
          }
          if (item?.children?.length === 0) {
            onParentClick(item);
          } else if (item?.children?.length > 0) {
            onParentClick(item);
          }
        }}
        style={{
          width: isWebMenu ? `100%` : 50,
          opacity: !item?.allowed ? 0.7 : 1,
          cursor: !item?.allowed ? 'not-allowed' : 'pointer'
        }}
      >
        <div>
          <div className={styles.icon}>
            <RenderIf isTrue={item?.svgIcon}>
              <SvgIcon iconName={item?.svgIcon} className={styles.navIcon} />
            </RenderIf>
          </div>
          <div
            style={{
              width: !isWebMenu ? 0 : ``,
              transition: `width 0.35s ease`,
              overflow: `hidden`,
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            {item?.label}
            {!item?.allowed && (
              <div className={styles.lockIconWrapper}>
                <Ikon name="lock" />
                <div className={styles.upgradeTooltip}>
                  Please upgrade your plan by contacting your admin
                </div>
              </div>
            )}
          </div>
        </div>
        <div className={!isWebMenu ? styles.itemSmtArrow : styles.itemWebArrow}>
          <RenderIf isTrue={item?.children?.length > 0}>
            <RenderIf isTrue={!isActive}>
              <Ikon name={`down-cert`} />
            </RenderIf>
            <RenderIf isTrue={isActive}>
              <Ikon name={`up-cert`} />
            </RenderIf>
          </RenderIf>
        </div>
        <RenderIf isTrue={!isWebMenu}>
          <div className={styles.tooltip}>{item?.label}</div>
        </RenderIf>
      </button>
      <RenderIf isTrue={item?.children?.length !== 0 && isActive}>
        {item?.children.map((citem, i) => (
          <div
            key={i}
            className={
              isWebMenu
                ? styles.subMenu
                : `${styles.subMenu} ${styles.smartSubMenu}`
            }
          >
            <button
              type={`button`}
              className={
                citem?.route === pathname
                  ? `${styles.navItem} ${styles.active}`
                  : styles.navItem
              }
              onClick={() => {
                if (!citem?.allowed) {
                  return; // Prevent navigation for paid features
                }
                onChildClick(citem);
              }}
              style={{
                width: isWebMenu ? `100%` : 50,
                opacity: !citem?.allowed ? 0.7 : 1,
                cursor: !citem?.allowed ? 'not-allowed' : 'pointer'
              }}
            >
              <div>
                <div className={styles.icon}>
                  <RenderIf isTrue={citem?.svgIcon}>
                    <SvgIcon iconName={citem?.svgIcon} className={styles.navIcon} />
                  </RenderIf>
                </div>
                <div
                  style={{
                    width: !isWebMenu ? 0 : ``,
                    transition: `width 0.35s ease`,
                    overflow: `hidden`,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  {citem?.label}
                  {!citem?.allowed && (
                    <div className={styles.lockIconWrapper}>
                      <Ikon name="lock" />
                      <div className={styles.upgradeTooltip}>
                        Please upgrade your plan by contacting your admin
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <RenderIf isTrue={!isWebMenu}>
                <div className={styles.tooltip}>{item?.label}</div>
              </RenderIf>
            </button>
          </div>
        ))}
      </RenderIf>
    </>
  );
};

export default function Aside({ userRole }) {
  const { brand, isWebMenu } = useStore((state) => state);
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const { countryCode } = useCountry();
  const [asideNav, setAsideNav] = useState(asideNavMain);
  const [activeParent, setActiveParent] = useState(null); // Track active parent label
  const { existingPlanData, existingPlanLoading } = useFetchExistingPlanHook(
    'existingPlan',
    brand?.id
  );
  useEffect(() => {
    // Filter nav items based on country restrictions
    let filteredNav = asideNavMain;
    if (countryCode) {
      filteredNav = asideNavMain.filter((item) => {
        if (item.countryRestricted) {
          return item.countryRestricted === countryCode;
        }
        return true;
      });
    }

    if (existingPlanData?.bundle?.features) {
      const features = existingPlanData?.bundle?.features;
      const newAsideNav = filteredNav?.map((item) => {
        let isAllowed = false;
        if (item?.label === 'Dashboard') {
          isAllowed = true;
        } else if (item?.label === 'Orders History') {
          isAllowed = true;
        } else if (item?.label === 'Payment Settings') {
          // Payment Settings is always allowed for PK country (already filtered)
          isAllowed = true;
        } else if (
          features?.find((f) => f?.slug === 'sds' && item?.label === 'SDS')
        ) {
          isAllowed = true;
        } else if (
          features?.find(
            (f) =>
              f?.slug === 'inventory_management' && item?.label === 'Inventory'
          )
        ) {
          isAllowed = true;
        } else if (
          features?.find(
            (f) =>
              f?.slug === 'menu_engineering' &&
              item?.label === 'Menu Engineering'
          )
        ) {
          isAllowed = true;
        } else if (
          features?.find(
            (f) =>
              f?.slug === 'recipe_engineering' &&
              item?.label === 'Recipe Engineering'
          )
        ) {
          isAllowed = true;
        } else if (item?.label === 'Demand Sensing') {
          isAllowed = true;
        } else if (item?.label === 'Kitchen Planning') {
          isAllowed = true;
        } else if (
          features?.find(
            (f) =>
              f?.slug === 'delivery_settings' &&
              item?.label === 'Delivery Settings'
          )
        ) {
          isAllowed = true;
        } else if (
          features?.find(
            (f) =>
              f?.slug === 'payment_settings' &&
              item?.label === 'Payment Settings'
          )
        ) {
          isAllowed = true;
        }
        if (isAllowed && item?.children?.length > 0) {
          const updatedChildren = item.children.map((child) => ({
            ...child,
            allowed: true
          }));
          return { ...item, allowed: true, children: updatedChildren };
        }
        if (item?.label === 'Food Waste') {
          isAllowed = true;
        }
        return { ...item, allowed: isAllowed };
      });
      setAsideNav(newAsideNav);
    } else {
      setAsideNav(filteredNav);
    }
  }, [existingPlanData, countryCode]);

  // Handler for parent click
  const handleParentClick = (item) => {
    if (item?.children?.length > 0) {
      setActiveParent(item.label);
      // Navigate to first child if not already there
      const firstChild = item.children[0];
      if (firstChild && firstChild.route && pathname !== firstChild.route) {
        navigate(firstChild.route);
      }
    } else if (item?.route) {
      setActiveParent(null);
      if (pathname !== item.route) {
        navigate(item.route);
      }
    }
  };

  // Handler for child click
  const handleChildClick = (child) => {
    if (child?.route && pathname !== child.route) {
      navigate(child.route);
    }
  };

  if (existingPlanLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%'
        }}
      >
        <Loading />
      </div>
    );
  }

  return (
    <aside
      className={styles.aside}
      style={{ overflowY: isWebMenu ? `auto` : `` }}
    >
      <RenderIf isTrue={userRole === 'SUPER_ADMIN'}>
        <RenderIf isTrue={brand?.brand_type === 'CLOUD'}>
          {asideNav?.length > 0 &&
            asideNav
              ?.filter(
                (nav) =>
                  nav.label === 'Dashboard' ||
                  nav.label === 'Portfolio' ||
                  nav.label === 'Online Store' ||
                  nav.label === 'SDS' ||
                  nav.label === 'KDS' ||
                  nav.label === 'Demand Planning'
              )
              .map((item, index) => {
                return (
                  <div key={index}>
                    <NavItem
                      item={item}
                      isActive={activeParent === item.label}
                      onParentClick={handleParentClick}
                      onChildClick={handleChildClick}
                      isWebMenu={isWebMenu}
                      pathname={pathname}
                    />
                  </div>
                );
              })}
        </RenderIf>
        <RenderIf isTrue={brand?.brand_type !== 'CLOUD'}>
          {asideNav?.length > 0 &&
            asideNav.map((item, index) => (
              <div key={index}>
                <NavItem
                  item={item}
                  isActive={activeParent === item.label}
                  onParentClick={handleParentClick}
                  onChildClick={handleChildClick}
                  isWebMenu={isWebMenu}
                  pathname={pathname}
                />
              </div>
            ))}
        </RenderIf>
      </RenderIf>
    </aside>
  );
}
